<template>
  <div>
    <main-title title="Información del comprador" />
    <b-row class="m-0">
      <b-col class="col-12 col-md-4">
        <b-form-group label="Nombre" label-for="name" invalid-feedback="Este campo es requerido"
          :state="formStatus.name">
          <b-form-input id="name" v-model="formData.name" trim :state="formStatus.name"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col class="col-12 col-md-4">
        <b-form-group label="Apellido" label-for="lastname" invalid-feedback="Este campo es requerido"
          :state="formStatus.lastname">
          <b-form-input
            id="lastname"
            v-model="formData.lastname"
            trim
            :state="formStatus.lastname"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col class="col-12 col-md-4">
        <b-form-group label="N° Documento" label-for="dni" invalid-feedback="Este campo es requerido"
          :state="formStatus.dni">
          <b-form-input id="dni" v-model="formData.dni" trim :state="formStatus.dni"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="m-0">
      <b-col class="col-12 col-md-8">
        <label>Dirección</label>
        <autocomplete :initvalue="formData.addresscords.text" @address-change="setAddresscords($event)" />
      </b-col>
      <b-col class="col-12 col-md-4">
        <b-form-group label="Piso, Dpto., Unidad" label-for="addressdetails">
          <b-form-input
            id="addressdetails"
            v-model="formData.addressdetails"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="m-0">
      <b-col class="col-12 col-md-8">
        <b-form-group label="Mail" label-for="mail" invalid-feedback="Este campo es requerido"
          :state="formStatus.mail">
          <b-form-input
            type="email"
            id="mail"
            v-model="formData.mail"
            trim
            :state="formStatus.mail"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col class="col-12 col-md-4">
        <b-form-group label="Teléfono / Celular" label-for="mainPhone" invalid-feedback="Este campo es requerido"
          :state="formStatus.mainPhone">
          <b-form-input
            type="text"
            id="mainPhone"
            v-model="formData.mainPhone"
            trim
            :state="formStatus.mainPhone"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="m-0 d-none">
      <b-col >
        <b-form-group label="Nuevo contacto" label-for="phonenumber">
          <b-form-input
            id="phonenumber"
            v-model="addPhoneFields.number"
            trim
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Tipo" label-for="phonetype">
          <b-form-select
            id="phonetype"
            v-model="addPhoneFields.type"
            :options="['Teléfono', 'Celular', 'Skype', 'Hangouts', 'Zoom']"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="auto">
        <b-button style="margin-top: 2rem;" @click="addDatatoList()"
          >Agregar</b-button
        >
      </b-col>
    </b-row>
    <b-row class="mx-0 mb-5">
      <b-col>
        <b-list-group>
          <b-list-group-item
            v-for="(item, index) in formData.phones"
            :key="index"
            class="d-flex"
          >
            <div>
              {{ item.number }}
              <span class="text-muted">( {{ item.type }} )</span>
            </div>
            <div
              class="ml-auto"
              style="cursor:pointer;"
              @click="removeDataItem(index)"
            >
              &times;
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <div class="d-flex m-2">
      <div
        class="rounded py-2 px-4 d-flex justify-content-between flex-fill subtotal-line"
        style="background: #f1f1f1;"
      >
        <div>Subtotal</div>
        <div class="d-none d-md-block">{{ cart }} items</div>
        <div>${{ calcSubtotal() }}</div>
      </div>
      <b-button
        size="sm"
        class="ml-3"
        style="background: #e8661a; border:none; line-height: 2rem; font-size: 1em;"
        
        @click="saveData()"
        >Siguiente</b-button
      >
    </div>
    <b-modal id="modal-login" title="Debe estar registrado para poder comprar" hide-header-close hide-footer no-close-on-backdrop no-close-on-esc>
      <form-login @login="usrRegister($event)" @cancel="nologin();" />
    </b-modal>
  </div>
</template>
<script>
import Autocomplete from "@/components/GoogleAutocomplete.vue";
import MainTitle from "@/components/MainTitle.vue";
import FormLogin from "@/components/FormLogin.vue";
import { mapState, mapGetters } from "vuex";
import axios from "axios";

export default {
  components: {
    Autocomplete,
    MainTitle,
    FormLogin
  },
  data: function() {
    return {
      formData: {
        name: "",
        lastname: "",
        phones: [],
        addresscords: {},
        addressdetails: "",
        mail: "",
        dni: "",
        mainPhone: ""
      },
      formStatus: {
        name: null,
        lastname: null,
        mail: null,
        dni: null,
        mainPhone: null
      },
      addPhoneFields: {
        number: "",
        type: ""
      },
      sessionCartItems: 0
    };
  },
  computed: {
    ...mapState({
      cartItems: state => state.cart.cartItems,
      isLogged: state => state.user.isLogged
    }),
    ...mapGetters({ cart: "countCartItems" })
  },
  mounted(){
    if (this.$parent.formData.step2){
      this.formData = Object.assign(this.formData, this.$parent.formData.step2);
    }
    if (!this.$parent.formData.step1){
      this.$router.push('/cart/step1');
    }
    if (!this.isLogged){
      this.$bvModal.show('modal-login');
    }else{
      this.getClientData();
    }
    this.sessionCartItems = this.cart
  },
  methods: {
    usrRegister(usrdata){
      this.formData.mail = usrdata.email;
      if (usrdata.name !== undefined){
        this.formData.name = usrdata.name;
      }
      if (usrdata.lastname !== undefined){
        this.formData.lastname = usrdata.lastname;
      }
      if (usrdata.document !== undefined){
        this.formData.dni = usrdata.document;
      }
      if (usrdata.address !== undefined){
        this.formData.addresscords = JSON.parse(usrdata.address);  
         /*
         this.formData.addresscords.text = decodeURI(this.formData.addresscords.text);
        console.log(this.formData.addresscords.text);
         */
        const container = document.createElement('div');
        container.innerHTML = this.formData.addresscords.text;
        this.formData.addresscords.text = container.textContent;
        
        console.log(container);
        
      }
      if (usrdata.addressdetails !== undefined){
        this.formData.addressdetails = usrdata.addressdetails;        
      }
      if (usrdata.phone !== undefined){
        this.formData.mainPhone = usrdata.phone;
      }
      this.$bvModal.hide('modal-login');

      setTimeout(function() {
        if (this.cart !== this.sessionCartItems) {
          this.$bvModal.msgBoxOk('Su carrito tenía guardados libros de su última sesión. Por favor revise su compra antes de continuar')
          .then(() => {
            this.$router.push('/cart/step1');
          })
        }
      }.bind(this), 1000)
    },
    async getClientData(){
      await axios
                .post(
                this.$store.state.user.siteData.location + "clients/clients/getOne",
                JSON.stringify({id: this.$store.state.user.usrid}),
                {
                    validateStatus(status) {
                    return status < 500; // Resolve only if the status code is less than 500
                    },
                    headers: {
                    "Content-Type": "application/json"
                    }
                }
                )
                .then(evtResponse => {
                    console.log(evtResponse.data);
                    const usrdata = evtResponse.data.records[0];
                    this.formData.mail = usrdata.email;
                    if (usrdata.name !== undefined){
                      this.formData.name = usrdata.name;
                    }
                    if (usrdata.lastname !== undefined){
                      this.formData.lastname = usrdata.lastname;
                    }
                    if (usrdata.document !== undefined){
                      this.formData.dni = usrdata.document;
                    }
                    if (usrdata.address !== undefined){
                      this.formData.addresscords = JSON.parse(usrdata.address);
                      const container = document.createElement('div');
                      container.innerHTML = this.formData.addresscords.text;
                      this.formData.addresscords.text = container.textContent;    
                    }
                    if (usrdata.addressdetails !== undefined){
                      this.formData.addressdetails = usrdata.addressdetails;        
                    }
                    if (usrdata.phone !== undefined){
                      this.formData.mainPhone = usrdata.phone;
                    }

                });
    },
    nologin(){
      this.$router.push('/cart/step1');
    },
    setAddresscords: function(newAddressCords) {
      this.formData.addresscords = newAddressCords;
    },
    addDatatoList: function() {
      if (this.addPhoneFields.number === '' || this.addPhoneFields.type === ''){
        this.$bvModal.msgBoxOk('No puede crear un contacto vacío y sin tipo', {
          title: 'Error',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
          });
        
        return;
      }
      this.formData.phones.push({
        number: this.addPhoneFields.number,
        type: this.addPhoneFields.type
      });
      this.addPhoneFields = {
        number: "",
        type: ""
      };
    },
    removeDataItem: function(itemIndex) {
      this.formData.phones.splice(itemIndex, 1);
    },
    getBookCost: function(itemType) {
      switch (parseInt(itemType)) {
        case 1:
          return 700;
        case 2:
          return 500;
        case 3:
          return 50;
      }
    },
    calcSubtotal: function() {
      let result = 0;
      if (this.$parent.formData.step1){
        result = this.$parent.formData.step1.precio;
      }
      return result;
    },
    saveData(){
      
      let valid = true;

      if (this.formData.name === ""){
        this.formStatus.name = false;
        valid = false;
      }
      if (this.formData.lastname === ""){
        this.formStatus.lastname = false;
        valid = false;
      }
      if (this.formData.mail === ""){
        this.formStatus.mail = false;
        valid = false;
      }
      if (this.formData.dni === ""){
        this.formStatus.dni = false;
        valid = false;
      }
      if (this.formData.mainPhone === ""){
        this.formStatus.mainPhone = false;
        valid = false;
      }
      
      if (valid){     
        this.formData.id = this.$store.state.user.usrid;
        axios
            .post(
            this.$store.state.user.siteData.location + "clients/clients/save",
            JSON.stringify(this.formData),
            {
                validateStatus(status) {
                return status < 500; // Resolve only if the status code is less than 500
                },
                headers: {
                "Content-Type": "application/json"
                }
            }
            )
            .then(evtResponse => {
                console.log(evtResponse.data);
            });


        this.$emit('change', {step2: this.formData});
        this.$router.push('/cart/step3');
      }else{
        this.$bvModal.msgBoxOk('Verifique la información ingresada', {
          title: 'Error',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
          });
      }
    }
  }
};
</script>
